import { Component, Input, OnInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { OperationsModel } from 'src/app/core/models/members/user/operations.model';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { OperationsService } from 'src/app/core/services/list-services/operations.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { AuthorizedOperations} from 'src/app/core/models/authorized-operations.model';
import { Roles, RoleValueAdmin, RoleValueCSR, RoleValueProfile, RoleValueSandbox, RoleValueWitness } from 'src/app/core/security/roles';
import { AuthContext } from 'src/app/core/models/auth-context.model';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { OperationAccess } from 'src/app/core/enums/operation-access-enum';

@Component({
  selector: 'app-user-permission-modal',
  templateUrl: './user-permission-modal.component.html',
  styleUrls: ['./user-permission-modal.component.scss']
})
export class UserPermissionModalComponent implements OnInit {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  userEdited: boolean = false;

  treeControl = new NestedTreeControl<OperationsModel>(node => node.children);
  dataSource = new MatTreeNestedDataSource<OperationsModel>();

  rolesList: string[] = [Roles.admin, Roles.globalAdmin, Roles.csr, Roles.profile, Roles.sandbox, Roles.witness]
  oldArrayList: string[] = []
  selectedRolesArray: string[] = []
  selectedAccessTypesArray: any[] = []
  operationAccessList: any[] = [{ name: "None", type: OperationAccess.None }, { name: "Full", type: OperationAccess.Full }, { name: "Inherited", type: OperationAccess.Inherited }, { name: "Custom", type: OperationAccess.Custom }];
  isRolesListOpen: boolean = false;
  isOperationAccessListOpen: boolean = false;
  operationsList!: Observable<OperationsModel>;
  isLoading!: Observable<Boolean>;
  operations?: any;
  contextOperations?: string[];
  outPutOperations: string[] = [];
  newContext: AuthContext = new AuthContext;
  isLoadingVal: boolean = false;
  @Input() public model: UserModel = new UserModel();

  constructor(
    private modalRef: NgbActiveModal,
    private myFileService: MyfileApiService,
    private toasterNotificationService: ToasterNotificationService,
    public operationsListService: OperationsService) {
    this.operationsList = this.operationsListService.resultItems$;
  }
  ngOnInit(): void {
    this.operationsListService.refresh();
    var sub = this.operationsList.subscribe((results: any) => {
      if (results && results[0] && results[0].name) {
        this.operations = results
        if (this.model.id) {
          var sub2 = this.myFileService.getSecurityAuthContextWithTenant(this.model.id, this.model.businessUnit?.tenantId!).subscribe(context => {
            if (!context) {
              context = new AuthContext();
              context.ownerId = this.model.id;
              context.id = this.model.id
              context.loginType = LoginType.User;
              context.authorizedOperations = new AuthorizedOperations;
              context.authorizedOperations.operationAccess = OperationAccess.None
              context.authorizedOperations.operations = []
            }
            
            this.newContext = context;
            if (context.authorizedOperations?.operationAccess == 0) {
              this.selectedAccessTypesArray = [{ name: "None", type: OperationAccess.None }]
            } else if (context.authorizedOperations?.operationAccess == 1) {
              this.selectedAccessTypesArray = [{ name: "Inherited", type: OperationAccess.Inherited }]
            } else if (context.authorizedOperations?.operationAccess == 2) {
              this.selectedAccessTypesArray = [{ name: "Custom", type: OperationAccess.Custom }]
            } else if (context.authorizedOperations?.operationAccess == 3) {
              this.selectedAccessTypesArray = [{ name: "Full", type: OperationAccess.Full }]
            }

            this.contextOperations = context.authorizedOperations?.operations;
            this.selectedRolesArray = context.roles;
            this.operations.forEach((element: OperationsModel, index: number) => {
              this.operations[index] = this.recursiveElements(element, this.contextOperations);
            })
          })
          this.unsubscribe.push(sub2)
        }
      }
    });
    this.unsubscribe.push(sub)
  }

  recursiveElements(element: OperationsModel, context: any, uncheckAll?: boolean, checkAll?: boolean): OperationsModel {
    if (checkAll == true) {
      element.isChecked = true;
      if (element.children && element.children.length > 1) {
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context, uncheckAll, checkAll)
        });
      }
    }
    if (uncheckAll == true) {
      element.isChecked = false;
      if (element.children && element.children.length > 1) {
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context, uncheckAll)
        });
      }
    } else {
      if (element.name) {
        if (context.includes(element.name)) {
          element.isChecked = true;
        }
      }
      if (element.children && element.children.length > 0) {
        var hasChildChecked: boolean = false; 
        element.children.forEach((childElem: OperationsModel) => {
          childElem = this.recursiveElements(childElem, context);
          if(childElem.isChecked == true){
            hasChildChecked = true;
          }
        });
        if(hasChildChecked){
          element.isChecked = true;
        }
      }
    }
    return element;
  }

  hasChild = (_: number, node: OperationsModel) => !!node.children && node.children.length > 0;

  close() {
    this.modalRef.close();
  }

  selectRole(rolesList: string[]) {
    if (rolesList.length == 0 || (rolesList.length < this.oldArrayList.length)) {
      this.operations.forEach((element: OperationsModel, index: number) => {
        this.operations[index] = this.recursiveElements(element, "", true);
      })
      this.selectedAccessTypesArray = [{ name: "None", type: OperationAccess.None }];
    }
    rolesList.forEach(role => {
      if (role == Roles.admin) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueAdmin);
        })
      } else if (role == Roles.csr) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueCSR);
        })
      } else if (role == Roles.profile) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueProfile);
        })
      } else if (role == Roles.sandbox) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueSandbox);
        })
      } else if (role == Roles.witness) {
        this.operations.forEach((element: OperationsModel, index: number) => {
          this.operations[index] = this.recursiveElements(element, RoleValueWitness);
        })
      }
      this.selectedAccessTypesArray = [{ name: "Inherited", type: OperationAccess.Inherited }]
    })
    this.oldArrayList = rolesList;
  }

  roleListController() {
    this.isRolesListOpen = !this.isRolesListOpen
  }
  accessTypeListController() {
    this.isOperationAccessListOpen = !this.isOperationAccessListOpen
  }

  ngOnDestroy() {
    this.operationsListService.clearListService();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  isChecked(element: OperationsModel, context: any): OperationsModel {
    if (element.name && element.isChecked) {
      this.outPutOperations.push(element.name)
    }
    if (element.children && element.children.length > 1) {
      element.children.forEach((childElem: OperationsModel) => {
        childElem = this.isChecked(childElem, context)
      });
    }
    return element;
  }
  setAllChildrenToParentNode(node: OperationsModel){
    node.children?.forEach((child:OperationsModel)=>{
      child.isChecked = node.isChecked;
    })
  }
  submit() {
    this.outPutOperations = [];
    this.operations.forEach((element: OperationsModel, index: number) => {
      this.operations[index] = this.isChecked(element, this.operations);
    })
    if (this.newContext.authorizedOperations) {
      this.newContext.authorizedOperations.operationAccess = this.selectedAccessTypesArray[0].type;
      this.newContext.authorizedOperations.operations = this.outPutOperations;
    }
    this.newContext.roles = this.selectedRolesArray;

    var sub3 = this.myFileService.updateSecurityAuthContextWithTenant(this.newContext,this.model.businessUnit!.tenantId!).subscribe((result) => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@: User permissions updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        this.close()
      }
      this.unsubscribe.push(sub3)
    })
  }

}
